export default {
  install(Vue) {
    Vue.use({
      install(Vue) {
        Vue.prototype.$prefetch = function () {
          if (this.$auth.check()) {
            this.$loader.disable();

            const calls = [];

            calls.push(this.$store.dispatch('models/order/loadStates'));
            calls.push(this.$store.dispatch('models/projection/loadStates'));
            calls.push(this.$store.dispatch('models/quotation/loadStates'));
            calls.push(this.$store.dispatch('models/campaign/fetchCampaigns'));

            Promise.all(calls).finally(() => {
              this.$loader.enable();
            });
          }
        };
      },
    });
  },
};
